import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import AutocaptureConfig from '../../libraries/ios/_snippets/autocapture-config-ios.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In web apps using the PostHog `}<a parentName="p" {...{
        "href": "/docs/libraries/ios"
      }}>{`iOS SDK`}</a>{`, the following data can be autocaptured.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Application Opened`}</strong>{`: when the app is opened from a closed state or when the app comes to the foreground (e.g. from the app switcher)`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Backgrounded`}</strong>{`: when the app is sent to the background by the user`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Installed`}</strong>{`: when the app is installed`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Updated`}</strong>{`: when the app is updated`}</li>
      <li parentName="ul"><strong parentName="li">{`$screen`}</strong>{`: when the user navigates if using `}<inlineCode parentName="li">{`UIViewController`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`$autocapture`}</strong>{`: when the user interacts with elements in a screen if using `}<inlineCode parentName="li">{`UIKit`}</inlineCode>{` `}</li>
    </ul>
    <p>{`This autocapture behavior can be further controlled using the `}<inlineCode parentName="p">{`PostHogConfig`}</inlineCode>{` object.`}</p>

    <AutocaptureConfig mdxType="AutocaptureConfig" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      